const MENU_BOUND_KEY = 'publicMobileMenuBound';

export function initPublicMobileMenu(root = document) {
  if (root.documentElement?.dataset[MENU_BOUND_KEY] === 'true') return;
  if (root.documentElement) root.documentElement.dataset[MENU_BOUND_KEY] = 'true';

  root.addEventListener('click', event => {
    const trigger = event.target.closest('[data-public-mobile-menu-trigger]');
    if (trigger) {
      event.preventDefault();
      setPublicMobileMenuOpen(root, true);
      return;
    }

    if (
      event.target.closest('[data-public-mobile-menu-close]') ||
      event.target.closest('[data-public-mobile-menu-backdrop]') ||
      event.target.closest('[data-public-mobile-menu-link]')
    ) {
      setPublicMobileMenuOpen(root, false, { restoreFocus: !event.target.closest('[data-public-mobile-menu-link]') });
    }
  });

  root.addEventListener('keydown', event => {
    const menu = root.querySelector('[data-public-mobile-menu]');
    if (!menu || menu.classList.contains('hidden')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      setPublicMobileMenuOpen(root, false);
    }
    if (event.key === 'Tab') {
      const controls = [...menu.querySelectorAll('a[href], button:not([disabled])')];
      const first = controls[0];
      const last = controls.at(-1);
      if (event.shiftKey && root.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && root.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    }
  });

  root.addEventListener('turbo:before-cache', () => setPublicMobileMenuOpen(root, false, { restoreFocus: false }));
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1280) setPublicMobileMenuOpen(root, false, { restoreFocus: false });
  });
}

export function setPublicMobileMenuOpen(root = document, open = false, { restoreFocus = true } = {}) {
  const menu = root.querySelector('[data-public-mobile-menu]');
  const backdrop = root.querySelector('[data-public-mobile-menu-backdrop]');
  const trigger = root.querySelector('[data-public-mobile-menu-trigger]');

  menu?.classList.toggle('hidden', !open);
  backdrop?.classList.toggle('hidden', !open);
  trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
  document.body?.classList.toggle('overflow-hidden', open);

  if (open) {
    const firstLink = menu?.querySelector('a, button');
    window.setTimeout(() => {
      if (menu && !menu.classList.contains('hidden')) firstLink?.focus();
    }, 0);
  } else {
    document.body?.classList.remove('overflow-hidden');
    if (restoreFocus) trigger?.focus();
  }
}
